import { render, staticRenderFns } from "./dialog--create-user.vue?vue&type=template&id=3d4a008d&"
import script from "./dialog--create-user.vue?vue&type=script&lang=js&"
export * from "./dialog--create-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports